var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"d-flex bread"},_vm._l((_vm.items),function(item,i){return _c('li',{key:i},[_c('a',{attrs:{"href":item.href},domProps:{"textContent":_vm._s(item.text)}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }